import {Component, Input} from '@angular/core';

import {TeamColorService} from '../../services/team-color.service';

@Component({
  selector: 'app-team-icon',
  imports: [],
  templateUrl: './team-icon.component.html',
  styleUrl: './team-icon.component.scss'
})
export class TeamIconComponent {
  @Input() teamId = '';

  constructor(private readonly teamColorService: TeamColorService) {
  }

  get colors(): { background: string; text: string } {
    return this.teamColorService.getColors(this.teamId);
  }
}
